module.exports = __webpack_public_path__ + "static/media/galdisa_blog_blog2.54f2a3b5.jpg";